import { useFeatureFlagEncountered } from 'hooks/analytics_events/useFeatureFlagEncountered'

export const useNewEmptyStates = () => {
  const isFlagEnabled = useFeatureFlagEncountered('activation_q3')
  return isFlagEnabled
}
